import axios from 'axios';
import React, { useEffect, useState } from 'react'

const FlightAirlineTable = ({ setUpdateData1, setGetTxnData1 }) => {
    const token = localStorage.getItem('token');
    const [data, setData] = useState([])
    const [searchOpt, setOpt] = useState('')
    
    const handleEdit = (item) => {
        setGetTxnData1(item)
        setUpdateData1('fUpdate')
    }
    useEffect(()=>{
        const fetchData=async()=>{
           try {
            const response=await axios.get(`https://bharatdarshan.app/api/admin/payment/get-fligh-airline-images`,{
                headers: {
                    Authorization: `Bearer ${token}`
                }
            })
              if (response?.data?.data?.length >0) {
                setData(response?.data?.data)
              }
            console.log({response:response?.data?.data});
           } catch (error) {
            console.log('====================================');
            console.log({error});
            console.log('====================================');
           }
        }
        fetchData()
    },[])
    const filteredData = data.filter(item => {
        if (!searchOpt) {
            return true; 
        }
        const lowerCaseSearchOpt = searchOpt.toLowerCase();
        return (
            item?.airlineName?.toLowerCase().includes(lowerCaseSearchOpt) ||
            item?.airlineCode?.toLowerCase().includes(lowerCaseSearchOpt) 
        )
    });
    return (
        <>
            <div className="row">
                <div className="col align-self-end">
                    <button onClick={() => setUpdateData1('fCreate')} >Add Operator</button>
                    {/* <button onClick={() => handleExportToExcel()} >Download</button> */}
                </div>
            </div>
            <hr />
            <div className="row">
               
                <div className="col-lg-3">
                    <input type="text" className="form-control" onChange={(e) => setOpt(e.target.value)} placeholder="Search Here" />
                </div>
            </div>
            <div className="row">
                <div className="col-12">
                    <table className='table'>
                        <thead>
                            <tr>
                                <th>Sl. No.</th>
                                <th>Airline Name</th>
                                <th>Airline Code</th>
                                <th>Airline Image</th>
                                
                                <th>Action</th>

                            </tr>
                        </thead>
                        <tbody>
                            {
                                filteredData?.map((item, index)=>{
                                    return(
                                        <tr key={index}>
                                           <td>{index+1}</td>
                                           <td>{item?.airlineName}</td>
                                           <td>{item?.airlineCode}</td>
                                           <td><img src={item?.airlineImage} height={50} width={50} /></td>
                                           <td><button onClick={() => handleEdit(item)}>Edit</button></td>
                                        </tr>
                                    )
                                })
                            }

                        </tbody>
                    </table>
                </div>
            </div>

        </>
    )
}

export default FlightAirlineTable
